import { Filter } from '@anytag/shared-molecules';
import { useInstagramInfluencersContext } from '../InstagramInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const InstagramInfluencersFilter = () => {
  const { filter, setFilter, isEngagementPage, isPackagePage } = useInstagramInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
